import type { FooterItem } from '@amp/web-app-components/src/components/Footer/types';

export const items: FooterItem[] = [
    {
        id: 'terms-of-use',
        url: 'ASE.Web.MusicClassical.Shared.Footer.TermsOfUse.URL',
        locKey: 'ASE.Web.MusicClassical.Shared.Footer.TermsOfUse.Text',
    },
    {
        id: 'privacy-policy',
        url: 'ASE.Web.MusicClassical.Footer.PrivacyPolicy.URL',
        locKey: 'ASE.Web.MusicClassical.Footer.PrivacyPolicy.Text',
    },
    {
        id: 'cookie-policy',
        url: 'ASE.Web.MusicClassical.Shared.Footer.CookiePolicy.URL',
        locKey: 'ASE.Web.MusicClassical.Shared.Footer.CookiePolicy.Text',
    },
    {
        id: 'get-help',
        url: 'ASE.Web.MusicClassical.Footer.GetHelp.URL',
        locKey: 'ASE.Web.MusicClassical.Footer.GetHelp.Text',
    },
    {
        id: 'feed-back',
        url: 'ASE.Web.MusicClassical.Footer.Feedback.URL',
        locKey: 'ASE.Web.MusicClassical.Footer.Feedback.Text',
    },
];
